let accessToken: string | undefined
const listeners = new Set<(token: string | undefined) => void>()

const notifyListeners = () => {
  for (const listener of listeners) {
    listener(accessToken)
  }
}

export const accessTokenStore = {
  get: () => accessToken,
  set: (token: string) => {
    accessToken = token
    notifyListeners()
  },
  clear: () => {
    accessToken = undefined
    notifyListeners()
  },
  subscribe: (listener: (token: string | undefined) => void) => {
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  },
}
